var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
import Text from '../text';
import * as Tooltip from '../tooltip';
const IconWrapper = styled.div `
  & > *:before {
    content: '';
    display: block;
    position: absolute;
    top: ${({ direction }) => ['TOP_RIGHT', 'TOP_CENTER', 'TOP_LEFT'].includes(direction)
    ? '-50%'
    : '50%'};
    width: 100%;
    height: 1rem;
  }
`;
const PopoverBox = styled.div `
  width: ${({ width }) => `${width / 16}rem`};
  text-align: left;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.INK_800};
`;
const PopoverTitle = styled.div `
  padding: 0.625rem;
  line-height: 1.25rem;
  background-color: ${({ theme }) => theme.colors.SNOW_300};
  border-radius: 6px;
`;
const PopoverContent = styled.div `
  padding: 1rem;
  line-height: 1.375rem;
`;
const Popover = (_a) => {
    var { title, content, children, width = 320, lang = 'en' } = _a, restProps = __rest(_a, ["title", "content", "children", "width", "lang"]);
    const getOverlay = () => {
        return (React.createElement(PopoverBox, { width: width },
            title && (React.createElement(PopoverTitle, null,
                React.createElement(Text, { weight: "Semibold", color: "INK_800", fontType: "Body", lang: lang }, title))),
            React.createElement(Text, { weight: "Regular", color: "INK_800", fontType: "Body", lang: lang },
                React.createElement(PopoverContent, null, content))));
    };
    return (React.createElement(Tooltip.Reverse, Object.assign({}, restProps, { overlay: getOverlay(), isArrowHide: true, delay: 100 }),
        React.createElement(IconWrapper, { direction: restProps.direction }, children)));
};
export default Popover;
//# sourceMappingURL=index.js.map